import React from "react";
import { Box, Typography } from "@mui/material";

const PreviewFooter = ({ data }) => (
  <Box>
    <Typography
      variant="caption"
      color="text.secondary"
      sx={{
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        display: "block",
        maxWidth: 400,
      }}
    >
      {data.description || "—"}
    </Typography>
    <Typography variant="caption" color="text.secondary">
      {data.contactEmail} · {data.contactPhone}
    </Typography>
  </Box>
);

export default PreviewFooter;